<template>
  <div class="mainClass">
    <!--机房IT设备功率-->
    <div class="powerDiv">
      <label class="lableClass">机房实时功率</label>
      <div class="deviceInfoBodyClass" v-if="powerOfRoomList.length > 0">
        <div style="height: 100%;overflow:auto;">
          <el-row class="rowClass" v-for="(item,index) in powerOfRoomList" :key="index">
            <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" class="firstCol">{{ item.name }}</el-col>
            <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" class="secondCol">{{ item.value }}</el-col>
            <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" class="thirdCol">kw</el-col>
          </el-row>
        </div>
      </div>
      <no-data style="text-align: center;margin-top: 18%" v-else></no-data>
    </div>
    <!--冷机实时功率-->
    <div class="powerDiv">
      <label class="lableClass">冷机实时功率</label>
      <div class="deviceInfoBodyClass" v-if="powerOfRefrigeratorList.length > 0">
        <div style="height: 100%;overflow:auto;">
          <el-row class="rowClass" v-for="(item,index) in powerOfRefrigeratorList" :key="index">
            <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" class="firstCol">{{ item.name }}</el-col>
            <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" class="secondCol">{{ item.value }}</el-col>
            <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" class="thirdCol">kw</el-col>
          </el-row>
        </div>
      </div>
      <no-data style="text-align: center;margin-top: 18%" v-else></no-data>
    </div>
    <!--动力设备-->
    <div class="powerDiv">
      <label class="lableClass">动力设备功率</label>
      <div class="deviceInfoBodyClass" v-if="powerDeviceList.length > 0">
        <div style="height: 100%;overflow:auto;">
          <el-row class="rowClass" v-for="(item,index) in powerDeviceList" :key="index">
            <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" class="firstCol">{{ item.name }}</el-col>
            <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" class="secondCol">{{ item.value }}</el-col>
            <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" class="thirdCol">kw</el-col>
          </el-row>
        </div>
      </div>
      <no-data style="text-align: center;margin-top: 18%" v-else></no-data>
    </div>
    <!--机房IT设备功率-->
    <div class="powerDiv">
      <label class="lableClass">照明和其他设备功率</label>
      <div class="deviceInfoBodyClass" v-if="otherDeviceList.length > 0">
        <div style="height: 100%;overflow:auto;">
          <el-row class="rowClass" v-for="(item,index) in otherDeviceList" :key="index">
            <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" class="firstCol">{{ item.name }}</el-col>
            <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" class="secondCol">{{ item.value }}</el-col>
            <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" class="thirdCol">kw</el-col>
          </el-row>
        </div>
      </div>
      <no-data style="text-align: center;margin-top: 18%" v-else></no-data>
    </div>

  </div>
</template>

<script>
import NoData from "@/components/NoData";
import {getRealTimePower} from '@/network/ems-record'

export default {
  name: "PowerofITEquipmentRoom",
  data() {
    return {
      // 机房IT设备功率列表
      powerOfRoomList: [],
      // 冷机实时功率列表
      powerOfRefrigeratorList: [],
      // 动力设备
      powerDeviceList: [],
      // 照明和其他设备
      otherDeviceList: []
    }
  },
  components: {
    NoData
  },
  mounted() {
    this.getRealTimePower()
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getRealTimePower:5000': this.getRealTimePower})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getRealTimePower')
  },
  methods: {
    getRealTimePower() {
      getRealTimePower().then(res => {
        if (res.code === 0 && res.data !== null) {
          this.powerOfRoomList = []
          this.powerOfRefrigeratorList = []
          this.powerDeviceList = []
          this.otherDeviceList = []
          res.data.forEach(item => {
            let powerOfRoom = {}
            powerOfRoom.name = item.cnName
            powerOfRoom.value = item.totalPower
            let powerOfRefrigerator = {}
            powerOfRefrigerator.name = item.cnName
            powerOfRefrigerator.value = item.frigeratorPower
            let powerDevice = {}
            powerDevice.name = item.cnName
            powerDevice.value = item.impetusPower
            let otherDevice = {}
            otherDevice.name = item.cnName
            otherDevice.value = item.otherPower
            // 排除掉数据为0的
            if (powerOfRoom.value !== 0) {
              this.powerOfRoomList.push(powerOfRoom)
            }
            if (powerOfRefrigerator.value !== 0) {
              this.powerOfRefrigeratorList.push(powerOfRefrigerator)
            }
            if (powerDevice.value !== 0) {
              this.powerDeviceList.push(powerDevice)
            }
            if (otherDevice.value !== 0) {
              this.otherDeviceList.push(otherDevice)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.mainClass {
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  overflow-y: auto;
}

.lableClass {
  font-size: 14px;
  color: #00E3F6;
  margin: 22px 0 14px 30px;
}

.powerDiv {
  height: 24%;
  width: 100%;
}

.deviceInfoBodyClass {
  height: 70%;
  width: 90%;
  text-align: center;
  margin: 0 auto 68px;
}

.rowClass {
  height: 28px;
  line-height: 28px;
  width: 100%;
  margin-bottom: 5px;
  background: linear-gradient(90deg, rgba(41, 155, 255, 0) 0%, rgba(41, 155, 255, 0.1) 52%, rgba(41, 155, 255, 0) 100%);
  border-radius: 3px 3px 3px 3px;
}

.firstCol {
  font-size: 14px;
  color: #FFFFFF;
  /* 内容过长显示成省略号（内容显示为一行） */
  white-space: nowrap; /*设置不换行*/
  overflow: hidden; /*设置隐藏*/
  text-overflow: ellipsis; /*设置隐藏部分为省略号*/
}

.secondCol {
  font-size: 16px;
  color: #299BFF;
}

.thirdCol {
  font-size: 12px;
  color: #99A2AA;
}
</style>
